import React from "react";
import "../css/MapSection.css";

const MapSection = () => {
  return (
    <section id="map-section">
      <div className="map-image-col" data-aos="fade-right">
        <img
          src="/wp-content/themes/cdl/images/map-imgs.jpg"
          alt="Colombo Dockyard PLC - Ship Yard Layout"
        />
      </div>

      <div className="map-content-col" data-aos="fade-left">
        <div className="map-text-wrapper">
          <h2>ShipYard Layout</h2>

          <p>
            Colombo Dockyard is a state of the art engineering entity that
            operates four graving drydocks with a maximum capacity of 125,000
            DWT and extensive repair berth facilities along with fully fledged
            workshops.
          </p>

          <a href="shipyard-Layout" className="learn-more">
            Learn more
          </a>
        </div>
      </div>
    </section>
  );
};

export default MapSection;